import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {RondeivuHttpClient} from "../../handlers";
import {map, Observable} from "rxjs";
import { INavItem, ITask } from 'src/app/models';
import { IUserActivity } from 'src/app/modules/dashboard/components/dashboard/dashboard.component';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private readonly BASE_URL = environment.rondeivu_api;
  private readonly FRAGMENT = '/appconfig';
  private readonly TASKS_FRAGMENT = '/tasks';
  private readonly CONTACT_US_FRAGMENT = '/contact-us';
  private readonly NAV_FRAGMENT = '/nav';
  private readonly DEAL_FRAGMENT = '/deal';
  private readonly EMPLOYEE_FRAGMENT = '/company';
  private readonly USER_ACTIVITY_FRAGMENT = '/requestAuditLog';

  constructor(private http: RondeivuHttpClient) {
  }

  /**
   * Fetch the users tasks
   * @todo REZA this filter is in here only for demo purposes to hide 2FA tasks (this is a stopgap, eventually it should be removed)
   */
  getTasks(): Observable<ITask[]> {
    if (environment.rondeivu_env_title === 'DEMO') {
      return this.http.get<ITask[]>(this.BASE_URL + this.FRAGMENT + this.TASKS_FRAGMENT).pipe(
        map((tasks: ITask[]) => 
          tasks.filter(task => task.message.includes("2FA") == false)
        )
      );
    }
    else {
      return this.http.get<ITask[]>(this.BASE_URL + this.FRAGMENT + this.TASKS_FRAGMENT);
    }
  }

  /**
   * Fetch the rondeivu contact information for the user
   */
  getContactInfo(): Observable<any> {
    return this.http.get(this.BASE_URL + this.FRAGMENT + this.CONTACT_US_FRAGMENT);
  }

  /**
   * Fetch the navigation items
   */
  getNavigationItems(): Observable<INavItem[]> {
    return this.http.get<INavItem[]>(this.BASE_URL + this.FRAGMENT + this.NAV_FRAGMENT);
  }

  /**
   * Fetch the deal tabs by deal id
   * @param dealId the deal id
   */
  getDealTabsByDealId(dealId: string): Observable<any> {
    return this.http.get(this.BASE_URL + this.FRAGMENT + this.DEAL_FRAGMENT + '/' + dealId);
  }

  /**
   * Fetch the employee tabs by employee id
   * @param employeeId the deal id
   */
  getEmployeeTabsByDealId(employeeId: string): Observable<any> {
    //TODO the employee tabs need to be provided based on the employee
    return this.http.get(this.BASE_URL + this.FRAGMENT + this.EMPLOYEE_FRAGMENT + '/' + employeeId);
  }

  getUserActivity(): Observable<any> {
    return this.http.get(this.BASE_URL + this.USER_ACTIVITY_FRAGMENT);
  }
}
